import XLSX from 'xlsx';
import { i18n } from 'src/i18n';
import ImporterSchema from 'src/modules/shared/importer/importerSchema';
import { Excel } from 'src/modules/shared/excel/excel';
import { saveAs } from 'file-saver';

export default class Importer {
  schema: ImporterSchema;

  constructor(fields) {
    this.schema = new ImporterSchema(fields);
  }

  downloadTemplate(templateFileName, predownloadTemplate, fixDownloadTemplate) {     
    var labels  = this.schema.labels;
    if(predownloadTemplate) {
      labels  = predownloadTemplate(labels);
    } 
    if(fixDownloadTemplate) {
      fetch(fixDownloadTemplate)
        .then(response => {
          if (!response.ok) {
            throw new Error('Error.');
          }
          return response.blob();
        })
        .then(blob => {
          saveAs(blob, templateFileName); 
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }    
    else {
      return Excel.exportAsCsvFile(
        [],
        labels,
        templateFileName
      );
    }
  }

  async castForDisplay(row, index) {
    return this.schema.castForDisplay(row, index);
  }

  async castForImport(row) {
    return this.schema.castForImport(row);
  }

  async convertExcelFileToJson(file, preprocessFn, preprocessExcelFn, skipHeader = true) {
    const workbook = await this._convertExcelFileToWorkbook(
      file,
      preprocessFn
    );
    const excelMacro = file.name.toLowerCase().endsWith('.xlsm');
    var json = XLSX.utils.sheet_to_json(
      workbook.Sheets[workbook.SheetNames[0]],
      {
        header: 1,
        blankrows: false,      
        range: skipHeader && !excelMacro? 1 : skipHeader && excelMacro ? 2 : undefined
      },
    );   
    if(excelMacro && preprocessExcelFn) {       
      json   = preprocessExcelFn(json);
    }    
    return json;
  }

  async _convertExcelFileToWorkbook(file, preprocessFn) {
    try {
      const excelMacro = file.name.toLowerCase().endsWith('.xlsm');
      const data = await this._readFile(file, preprocessFn, excelMacro);
      return XLSX.read(data, {
        type: !excelMacro?'string':'array',
        cellDates: !excelMacro,
      });
    } catch (error) {
      throw new Error(
        i18n('importer.errors.invalidFileUpload'),
      );
    }
  }

  async _readFile(file, preprocessFn, excelMacro) {
    if (!file) {
      return null;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          if (!e || !e.target) {
            reject(new Error());
            return;
          }
          if(!excelMacro) {
            var textContent = e.target.result as string;  
            if(preprocessFn) {
              textContent   = preprocessFn(textContent);
            }                 
            resolve(textContent);
          } else {
            const data = new Uint8Array(
              e.target.result as any,
            );
            resolve(data);
          }          
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (e) => {
        reject();
      };

      if(!excelMacro) {
        reader.readAsText(file);
      } else {
        reader.readAsArrayBuffer(file);
      }  
    });
  }
}
